import React, { useState, useEffect } from 'react';
import styled from 'styled-components/macro';
import Colors from './Colors';

const Text = styled.p`
  text-align: ${({ align }) => (align ? align : 'right')};
  font-size: small !important;
  color: ${({ isLimitReached }) => (isLimitReached ? Colors.OT_RED : '#000')};
`;

const CharacterCounter = ({ align = 'right', string = '', maxLength }) => {
  const [isLimitReached, setIsLimitReached] = useState(
    string.length >= maxLength
  );

  useEffect(() => {
    setIsLimitReached(string.length >= maxLength);
  }, [string]);

  return (
    <Text {...{ align, isLimitReached }}>{`(${string.length} / ${maxLength})`}</Text>
  );
};

export default CharacterCounter;
